import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppSvgIconComponent } from '@vallift/ngl';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [RouterLink, AppSvgIconComponent],
  templateUrl: './page-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  readonly title = input.required<string>();
  readonly description = input<string>();
  readonly backLabel = input<string>();
  readonly backLink = input<string | readonly unknown[]>();
}
